import { usePostSwitchMutate } from './use-post-switch-mutate';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useCallback } from 'react';

export const useUserSwitchMutation = () => {
  const navigate = useNavigate();
  
  const { mutate, isPending } = usePostSwitchMutate({
    queryOptions: {
      onSuccess: (data) => {
        if (data.id) {
          toast.success(`Переключено на користувача: ${data.meta?.firstName || data.id}`);
        }
        navigate('/');
      },
      onError: () => {
        toast.error('Помилка при переключенні користувача');
      },
    },
  });

  const switchUser = useCallback((userId: string) => {
    mutate({
      body: { id: userId },
    });
  }, [mutate]);

  return {
    switchUser,
    isPending,
  };
};
